class PlateSearchModal extends HTMLElement {
  constructor() {
    super();
    this.drawer = document.getElementById("plate-search-panel");
    this.overlay = document.getElementById("plate-search-modal-overlay");
    this.onBodyClick = this.handleCloseClick.bind(this);
    this.onBodyOpenClick = this.handleOpenClick.bind(this);

    this.openTriggers = document.querySelectorAll(
      ".js-btn-open-plate-search-modal"
    );
    this.closeTiggers = document.querySelectorAll(
      ".js-btn-close-plate-search-modal"
    );

    this.openTriggers.forEach((btn) => {
      btn.addEventListener("click", this.onBodyOpenClick);
    });

    this.closeTiggers.forEach((btn) => {
      btn.addEventListener("click", this.onBodyClick);
    });
  }

  async connectedCallback() {}

  open() {
    // this.removeAttribute("hidden");
    this.classList.toggle("pointer-events-none");

    this.overlay.classList.remove("opacity-0");
    this.overlay.classList.add("opacity-100");

    this.drawer.classList.remove("translate-y-20");
    this.drawer.classList.add("translate-y-0");
    this.drawer.classList.remove("opacity-0");
    this.drawer.classList.add("opacity-100");

    // this.notification.addEventListener('transitionend', () => {
    //   this.notification.focus();
    //   trapFocus(this.notification);
    // }, { once: true });

    this.overlay.addEventListener("click", this.onBodyClick);
  }

  close() {
    // this.setAttribute("hidden", true);
    this.classList.toggle("pointer-events-none");
    this.overlay.classList.remove("opacity-100");
    this.overlay.classList.add("opacity-0");

    this.drawer.classList.remove("translate-y-0");
    this.drawer.classList.add("translate-y-20");
    this.drawer.classList.remove("opacity-100");
    this.drawer.classList.add("opacity-0");

    this.overlay.removeEventListener("click", this.onBodyClick);

    // removeTrapFocus(this.activeElement);
  }

  handleCloseClick(evt) {
    const target = evt.target;

    this.close();
  }

  handleOpenClick(evt) {
    this.open();
  }
}

customElements.define("plate-search-modal", PlateSearchModal);
